var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentCad = function SvgDocumentCad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#documentCad_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DED8E6",
    d: "M27.666 35H7.334a2.905 2.905 0 0 1-2.905-2.905V2.905C4.43 1.3 5.73 0 7.334 0h13.33c.743 0 1.457.284 1.996.795l7.002 6.624c.58.548.909 1.311.909 2.11v22.566c0 1.605-1.3 2.905-2.905 2.905"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E79AB",
    d: "M29.662 7.419 22.66.795A2.9 2.9 0 0 0 20.664 0H17.5v35h10.166c1.604 0 2.905-1.3 2.905-2.905V9.53c0-.799-.329-1.562-.909-2.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#432E60",
    d: "M22.873 8.714h7.58a2.9 2.9 0 0 0-.79-1.295L22.66.795A2.9 2.9 0 0 0 21.421.1v7.16c0 .802.65 1.453 1.452 1.453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.132 30.592q0-.416.18-.74.18-.328.5-.508.324-.184.732-.184.5 0 .856.264t.476.72h-.752a.6.6 0 0 0-.24-.268.66.66 0 0 0-.348-.092.65.65 0 0 0-.512.22q-.195.22-.196.588 0 .367.196.588.195.22.512.22.196 0 .348-.092a.6.6 0 0 0 .24-.268h.752q-.12.456-.476.72-.356.26-.856.26-.408 0-.732-.18a1.3 1.3 0 0 1-.5-.508 1.5 1.5 0 0 1-.18-.74m4.91.912h-1.047l-.168.496h-.716l1.016-2.808h.792L12.935 32h-.724zm-.175-.528-.348-1.028-.344 1.028zm2.43-1.784q.443 0 .775.176t.512.496q.184.316.184.732 0 .412-.184.732-.18.32-.516.496a1.6 1.6 0 0 1-.772.176h-1.052v-2.808zm-.045 2.216q.388 0 .604-.212t.216-.6-.216-.604-.604-.216h-.324v1.632z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "documentCad_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35v35H0z"
  })))));
};
export default SvgDocumentCad;